

export const getPledgerBasedUrl = (path : string) => process.env.REACT_APP_WS_BASE_URL + '/pledger'+path;

